var $ = require('jquery');
/**
 * 表单文本控件：加类to-uppercase输入值转大写，加类to-lowercase输入值转小写
 */
$(document).off('keyup.trf.textTransform').on('keyup.trf.textTransform','.to-uppercase,.to-lowercase',function () {
    var $this = $(this);
    var val = this.value;
    if($this.is('.to-uppercase')){
        val = this.value.toUpperCase();
    }else if($this.is('.to-lowercase')){
        val = this.value.toLowerCase();
    }
    if(val!==this.value){
        this.value = val;
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/components/text-transform.js
// module id = 192
// module chunks = 0